// extracted by mini-css-extract-plugin
export default {"search":"ProductSimpleSearch_search__g7ubv"};